<template>
    <div class="assign-button">
        <a @click.stop="onPlus" v-if="plusActive">
            <v-icon
                :color = "hasAssignableEntries ? 'success' : 'secondary'"
                class  = "toolbar-button"
                size   = "20"
            >
                mdi-plus-box
            </v-icon>
        </a>

        <a @click.stop="onMinus" v-if="minusActive">
            <v-icon
                :color = "hasDissolvableEntries ? 'red' : 'secondary'"
                class  = "toolbar-button"
                size   = "20"
            >
                mdi-minus-box
            </v-icon>
        </a>
    </div>
</template>

<script>
export default {
    name: "PAssignButtons",

    props: {
        /**
         * True if the + button should be displayed
         */
        plusActive: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        /**
         * True if the - button should be displayed
         */
        minusActive: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        /**
         * The units of a location if the buttons belong to al location. Null, if the buttons belong to a single unit
         */
        units: {
            required: false,
            default : function () {
                return null;
            }
        }
    },

    computed: {
        hasAssignableEntries () {
            if (!this.units) {
                return true;
            }

             return this.units.find (unit => !unit.order || !unit.order.id);
        },

        hasDissolvableEntries () {
            if (!this.units) {
                return true;
            }

            return !!this.units.find (unit => !!unit.order);
        }
    },

    methods: {
        onPlus () {
            if (!this.hasAssignableEntries) {
                return;
            }

            this.$emit ("plus");
        },

        onMinus () {
            if (!this.hasDissolvableEntries) {
                return;
            }

            this.$emit ("minus");
        },
    }
}
</script>

<style scoped>

.assign-button {
    display: flex;
    min-width: 30px
}

</style>